import React from 'react';
import { ContentReveal } from 'web-ui-components/lib/molecules/accordions';

import { default as content } from '../AddNewPayeeLandingPage/index.content';
import { IBANMandatoryCountries } from '../../../config';

const InternationalPayeeAccountInfo = () => {
	const {
		internationalPayeeAccountInfoHeader,
		internationalPayeeAccountInfoTitle1,
		internationalPayeeAccountInfoBodyPart1,
		internationalPayeeAccountInfoTitle2,
		internationalPayeeAccountInfoBodyPart2,
		ibanMandatoryCountriesLabel,
	} = content;
	return (
		<ContentReveal header={internationalPayeeAccountInfoHeader}>
			<h4>{internationalPayeeAccountInfoTitle1}</h4>
			{internationalPayeeAccountInfoBodyPart1.map((body, index) => (
				<p key={index.toString()}>{body}</p>
			))}
			<h4>{ibanMandatoryCountriesLabel}</h4>
			<p>
				{IBANMandatoryCountries.map((country, index) => {
					if (IBANMandatoryCountries.length - 1 === index) {
						return country;
					}
					return `${country}, `;
				})}
			</p>
			<h4>{internationalPayeeAccountInfoTitle2}</h4>
			{internationalPayeeAccountInfoBodyPart2.map((body, index) => (
				<p key={index.toString()}>{body}</p>
			))}
		</ContentReveal>
	);
};

export default InternationalPayeeAccountInfo;
